import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/frontend/frontend/frontastic/renderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/frontend/frontend/helpers/padi/slo/subscription/onDelete.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/frontend/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/frontend/frontend/providers/index.tsx");
